import Switch from "@mui/material/Switch";
import TooltipButton from "../../../components/tooltip/Popover";
import VideocamIcon from "@mui/icons-material/Videocam";

const GoogleMeetSwitch = ({
  label = "CREATE GOOGLE MEET",
  isChecked = false,
  onSwitchChange,
  fieldName
}) => {
  return (
    <div
      style={{
        marginTop:"10px",
        borderRadius: "12px",
        padding: "12px 14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "var(--brand-light)",
        border: "1px solid rgba(26, 111, 212, .15)",
      }}
    >

      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          style={{
            background: "rgba(26, 111, 212, 0.1)",
            padding: "8px",
            borderRadius: "8px",
            display: "flex",
          }}
        >
          <VideocamIcon style={{ fontSize: "26px", color: "#3b8fe8" }} />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ fontWeight: 600, fontSize: "15px", color: "#1a1a1a" }}>
            {label}
          </span>

          {fieldName && <p className="isfiledd">
            <TooltipButton fieldName={fieldName} />
            </p>}
        </div>
      </div>

      <Switch
        checked={isChecked}
        onChange={onSwitchChange}
        sx={{
          transform: "scale(1.25)",

          "& .MuiSwitch-switchBase": {
            color: "#fff",
          },

          "& .MuiSwitch-track": {
            borderRadius: "20px",
            backgroundColor: "#d9e6fb",
            opacity: 1,
          },

          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            background: "linear-gradient(135deg, #1a6fd4, #3b8fe8)",
            opacity: 1,
          },

          "& .MuiSwitch-thumb": {
            width: "18px",
            height: "18px",
          },
        }}
      />
    </div>
  );
};

export default GoogleMeetSwitch;